<template>
    <section class="transaction-box">
        <title-date-component :titleOption="titleOption"></title-date-component>
        <section class="data-box">
            <line-tips-component style="margin-top:45px; width:150px;" :lineTipsInfo="lineTipsInfo"></line-tips-component>
            <section class="funnel">
                <section><span>浏览</span></section>
                <section><span>下单</span></section>
                <section><span>支付</span></section>
            </section>
            <section class="data">
                <section>
                    <span title="浏览用户数量"><i>访客数</i>{{ resultData.intentionUV | dataformat }}</span>
                </section>
                <section>
                    <span title="所售商品有下单行为的用户数量"><i>下单用户数</i>{{ resultData.orderUserNum | dataformat }}</span>
                </section>
                <section>
                    <span title="产生的支付行为的用户数量"><i>支付用户数</i>{{ resultData.payUserNum | dataformat }}</span>
                </section>
            </section>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .transaction-box {
        background-color: #FFF;
        border-radius: 3px;
        height: 360px;
        overflow: hidden;
        .title-date {
            margin-top: 10px;
            padding: 0 20px;
        }
        .data-box {
            width: 100%;
            height: 255px;
            padding-left: 40px;
            margin-top: 25px;
            overflow: hidden;
            position: relative;
            .funnel {
                width: 238px;
                height: 100%;
                float: left;
                position: relative;
                left: -90px;
                z-index: 1;
                margin-left: 20px;
                section {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    span {
                        position: absolute;
                        top: -50px;
                        color: #FFF;
                    }
                    &:nth-child(1) {
                        width: 100%;
                        border-top: 85px solid #64C8FD;
                        border-left: 35px solid #FFF;
                        border-bottom: 0;
                        border-right: 35px solid transparent;
                    }
                    &:nth-child(2) {
                        width: 168px;
                        border-top: 85px solid #4AB9FC;
                        border-left: 35px solid transparent;
                        border-bottom: 0;
                        border-right: 35px solid transparent;
                        margin-left: 35px;
                    }
                    &:nth-child(3) {
                        width: 98px;
                        border-top: 85px solid #29A3FC;
                        border-left: 35px solid #FFF;
                        border-bottom: 0;
                        border-right: 35px solid transparent;
                        margin-left: 70px;
                    }
                }
            }
            .data {
                height: 100%;
                width: 32%;
                position: absolute;
                left: 370px;
                overflow: hidden;
                > section {
                    height: 85px;
                    &:nth-child(1) {
                        background-color: #F7F9FA;
                    }
                    &:nth-child(3) {
                        background-color: #F7F9FA;
                    }
                    > span {
                        display: inline-block;
                        height: 100%;
                        width: 100%;
                        line-height: 85px;
                        font-size: 22px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        > i {
                            font-size: 14px;
                            font-style: normal;
                            width: 82px;
                            text-align: right;
                            display: inline-block;
                            margin-right: 15px;
                            color: #142C3D;
                            vertical-align: top;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../../components/title-date/TitleDate.vue'
    import LineTipsComponent from '../../../../operateData/components/line-tips/LineTips.vue'
    import dataformat from '../../../../filters/data-format'

    export default {
        components: {
            LineTipsComponent,
            TitleDateComponent
        },
        filters: {
            dataformat
        },
        data () {
            return {
                titleOption: {
                    title: '交易分析',
                    more: true,
                    moreUrl: 'menpiaoTransactionData'
                },
            }
        },
        props: ['resultData'],
        computed: {
            // 访购率指标
            lineTipsInfo () {
                return {
                    name: '访购率',
                    value: this.resultData.visitPurchaseRate,
                    unit: '%',
                    compare: this.resultData.visitPurchaseRatePercent,
                    title: '支付用户数/浏览用户数',
                    compareInfo: this.resultData.compareInfo
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Transaction.vue?a74704d0